import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqItems } from '../data/mock';

export const FAQSection = () => {
  return (
    <section id="faq" className="py-20 md:py-32 bg-bg-page">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-wash text-accent-text text-sm font-medium mb-4">
            FAQ
          </span>
          <h2 className="heading-2 mb-4">
            Domande<br />
            <span className="text-accent-text">Frequenti</span>
          </h2>
          <p className="body-large text-text-secondary">
            Tutto quello che devi sapere su EasyVI.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-2xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item) => (
              <AccordionItem 
                key={item.id} 
                value={item.id}
                className="product-card border-none px-6"
              >
                <AccordionTrigger className="text-left font-semibold text-text-primary hover:no-underline py-4">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-text-secondary pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
